module.exports = __webpack_public_path__ + "media/application/images/svgs/thumbs-down-2324b48b8be6e05846e447dcd0b1560e.svg";